import { render, staticRenderFns } from "./reisetermin-card-vorgaenge-release-process-reiseleistungen.vue?vue&type=template&id=56ce0385&scoped=true"
import script from "./reisetermin-card-vorgaenge-release-process-reiseleistungen.vue?vue&type=script&lang=js"
export * from "./reisetermin-card-vorgaenge-release-process-reiseleistungen.vue?vue&type=script&lang=js"
import style0 from "./reisetermin-card-vorgaenge-release-process-reiseleistungen.vue?vue&type=style&index=0&id=56ce0385&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ce0385",
  null
  
)

export default component.exports